import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const CancelModal = ({
    open,
    onClose,
    title,
    description,
    confirmText = "Po",
    cancelText = "Jo",
    onConfirm,
    onCancel
}) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box sx={{ width: 400, bgcolor: 'background.paper', borderRadius: '4px', boxShadow: 24, p: 4 }}>
                <Typography id="modal-title" variant="h5">{title}</Typography>
                <Typography id="modal-description" variant="body1">{description}</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                    <Button variant="contained" color="secondary" onClick={onConfirm}>
                        {confirmText}
                    </Button>
                    <Button variant="contained" onClick={onCancel || onClose}>
                        {cancelText}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default CancelModal;
